import { StackProps } from '@mui/material';
import { memo } from 'react';
import { AnalysisCustomBlock } from '@/types';
import { useCustomBlockListItemData } from './useCustomBlockListItemData';
import { RowListItem } from '@/components/shared/RowListItem';

type Props = {
  block: AnalysisCustomBlock;
} & StackProps;

export const CustomBlockListItem = memo(({ block, ...rest }: Props) => {
  const {
    area,
    hasInvalidPrism,
    loadingPaintRegion,
    onChange,
    onClick,
    selectedDefectValue,
    unitSuffix,
    isHovered,
    isSelected,
  } = useCustomBlockListItemData({ block });

  return (
    <RowListItem
      {...rest}
      label={block.name}
      primaryValue={selectedDefectValue}
      secondaryValue={area}
      unit={unitSuffix}
      checkboxDisabled={hasInvalidPrism || loadingPaintRegion}
      onCheckboxChange={onChange}
      onLabelClick={onClick}
      isHovered={isHovered}
      isSelected={isSelected}
      StackProps={rest}
    />
  );
});
